import React from "react";
import BaamerProject from "../../../models/classes/baamer-project.ts";
import ProjectLock from "../../../models/classes/project-lock.ts";
import ProjectLockStatus from "../../../models/enums/project-lock-status.ts";

export interface ProjectContextProps {
    project: BaamerProject;
    projectLockStatus: ProjectLockStatus;

    updateProjectIds: () => Promise<void>;

    refetchLockStatus: () => Promise<ProjectLock | undefined>;
    lockProject: () => Promise<void>;
    unlockProject: () => Promise<void>;
}

export const ProjectContext = React.createContext<ProjectContextProps | undefined>(undefined);